<mat-button-toggle-group [formControl]="state.form" [value]="state.form.value">
  @for (option of state.options; track option.value) {
    <mat-button-toggle [value]="option.value">
      <div class="fo-toggle-content">
        <span class="fo-name">{{ option.name }}</span>
        @if (option.subtitle) {
          <span class="fo-subtitle">{{ option.subtitle }}</span>
        }
      </div>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
@if (state.form.errors) {
  <div class="fo-error">Required</div>
}
